module.exports = __webpack_public_path__ + "static/media/logo.e33da5f9.jpeg";